import React from "react";
import { Col, Container, Row } from "reactstrap";
import Sites from "../containers/sites";

const SitesView = (props) => {
  return (
    <Container className="dashboard">
      <Row>
        <Col lg="12" md="12" sm="12">
          <h3 className="page-title">Sites Overview</h3>
          <h3 className="page-subhead subhead">Listed below are all the sites that you have access to. Not seeing a site you are meant to? Contact your administrator.</h3>
        </Col>
      </Row>
      <Sites />
    </Container>
  );
};

export default SitesView;
